import React from 'react';
import {Field, reduxForm} from 'redux-form';
import {validators} from '../../core';
import {gettext} from '../../../translations';

export const authenticationFields = {
    USERNAME: 'username',
    PASSWORD: 'password',
};


const renderField = ({input, label, placeholder, type, meta: {touched, error, warning}}) => (
    <div className={`form-group ${ (touched && error) ? 'u-has-error-v1' : ''} mb-4`}>
        <input {...input}
               placeholder={placeholder}
               type={type}
               className="form-control rounded g-py-15 g-px-15"
        />
        {touched && ((error && <small className="form-control-feedback">{error}</small>) || (warning &&
        <span>{warning}</span>))}
    </div>
);


const AuthenticationForm = (props) => {
    const {handleSubmit, submitting, loading} = props;
    return (
        <form className="g-py-15" onSubmit={handleSubmit}>

            <Field name={authenticationFields.USERNAME}
                   type="text"
                   component={renderField}
                   placeholder={gettext("Username or email address")}
                   validate={[validators.required]}
            />

            <Field name={authenticationFields.PASSWORD}
                   type="password"
                   component={renderField}
                   placeholder={gettext("Password")}
                   validate={[validators.required]}
            />

            <button type="submit"
                    disabled={submitting}
                    className="btn btn-block u-btn-primary g-color-white g-bg-primary-dark-v1--hover g-font-weight-600 g-font-size-12 text-uppercase rounded-0 g-px-25 g-py-15 " style={{position: 'relative'}}>

                {loading &&
                <div className={`lds-ring lds-ring-white`}
                     style={{borderColor: 'white', position: 'absolute', marginLeft: -20, marginTop: 4}}>
                    <div></div>
                </div>
                }

                {gettext('Sign in')}
            </button>
        </form>
    )
};

export default reduxForm({
    form: 'authentication',
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
})(AuthenticationForm)

